import TrashIcon from 'assets/icons/trash.svg';
import { InputField, MyCheckbox } from 'components';
import InfoTooltip from 'components/InfoTooltip';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { getOrganizationInfoFromLocalStorage } from 'utils/functions';
import { fontConfig } from "theme/fontConfig";
const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;
const OptionalTypesItems = ({ formik, index, variantIndex, removeVariantHandler, acceptNumbersAndGtZero }) => {
  const orgDetails = getOrganizationInfoFromLocalStorage();

  return (
    <>
      <Row style={{
        marginBottom: '20px',
        position: 'relative'
      }}>
        <Col className="col-sm-6">
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
            <label style={{ fontFamily: fontConfig.GeneralLabelFieldFont.family, fontWeight: '500', fontSize: '12px', color: '#4F4F4F', marginBottom: 0 }}>Variant <span style={{ color: 'red' }}>*</span></label>
            <InfoTooltip text="A label to identify this variant. E.g., 'Small', 'Large', 'Boys Uniform'." />
          </div>
          <InputField
            titleStyle={{
              fontFamily: fontConfig.GeneralInputFieldFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
            style={{ background: '#f6f6f6', color: '#002E5C' }}
            formStyle={{ marginBottom: 0 }}
            mandatory={true}
            formik={formik}
            title="none"
            name={`prices[${index}].variantInfo[${variantIndex}].name`}
            placeholder="Variant"
            checkValidation={true}
            value={
              formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.name
            }
            handleChange={(e) => {
              const value = e?.target?.value;
              if (value.length > 30) return;
              formik.setFieldValue(`prices.${index}.variantInfo.${variantIndex}.name`, value);
              if (!value) {
                formik.setFieldError(`prices[${index}].variantInfo[${variantIndex}].name`, 'Required');
                formik.setFieldTouched(`prices[${index}].variantInfo[${variantIndex}].name`, true);
              }
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
            }}
          />
        </Col>
        <Col className="col-sm-6">
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
            <label style={{ fontFamily: fontConfig.GeneralLabelFieldFont.family, fontWeight: '500', fontSize: '12px', color: '#4F4F4F', marginBottom: 0 }}>Quantity <span style={{ color: 'red' }}>*</span></label>
            <InfoTooltip text="Number of this variant available across all registrations. E.g., 20 uniforms, 15 spots." />
          </div>
          <InputField
            titleStyle={{
              fontFamily: fontConfig.GeneralInputFieldFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
            style={{ background: '#f6f6f6', color: '#002E5C' }}
            formStyle={{ marginBottom: 0 }}
            mandatory={true}
            formik={formik}
            title="none"
            name={`prices[${index}].variantInfo[${variantIndex}].quantity`}
            placeholder="Quantity"
            checkValidation={true}
            value={
              formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.quantity
            }
            handleChange={(e) => {
              const value = acceptNumbersAndGtZero(e?.target?.value.match(regex)[0]);
              if (parseFloat(value) > 10000) return;
              formik.setFieldValue(`prices[${index}].variantInfo[${variantIndex}].quantity`, value);
              if (!value) {
                formik.setFieldError(`prices[${index}].variantInfo[${variantIndex}].quantity`, 'Required');
                formik.setFieldTouched(`prices[${index}].variantInfo[${variantIndex}].quantity`, true);
              }
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
            }}
            disabled={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.infiniteQuantity}
          />
        </Col>
        <div
          className="optional_type-remove-icon"
          onClick={() => { if (variantIndex !== 0) removeVariantHandler(index, variantIndex); }}
          style={{ opacity: variantIndex === 0 ? 0.3 : 1, cursor: variantIndex === 0 ? 'not-allowed' : 'pointer' }}
        >
          <img src={TrashIcon} alt="" />
        </div>
      </Row>
      <Row style={{
        marginBottom: '20px',
        justifyContent: 'center'
      }}>
        <Col className="col-sm-6">
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
            <label style={{ fontFamily: fontConfig.GeneralLabelFieldFont.family, fontWeight: '500', fontSize: '12px', color: '#4F4F4F', marginBottom: 0 }}>Price <span style={{ color: 'red' }}>*</span></label>
            <InfoTooltip text="The price families pay for this variant." />
          </div>
          <InputField
            titleStyle={{
              fontFamily: fontConfig.GeneralInputFieldFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
            style={{ background: '#f6f6f6', color: '#002E5C' }}
            formStyle={{ marginBottom: 0 }}
            mandatory={true}
            formik={formik}
            title="none"
            name={`prices[${index}].variantInfo[${variantIndex}].amount`}
            placeholder={"Price"}
            checkValidation={true}
            value={
              formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.amount
            }

            handleChange={(e) => {
              const { value } = e.target;
              const updatedValue = value.match(regex)[0] >= 1 ? value.match(regex)[0] : '';
              if (parseFloat(updatedValue) > 1000000) return;
              formik.setFieldValue(`prices[${index}].variantInfo[${variantIndex}].amount`, updatedValue);
              if (!updatedValue) {
                formik.setFieldError(`prices[${index}].variantInfo[${variantIndex}].amount`, 'Required');
                formik.setFieldTouched(`prices[${index}].variantInfo[${variantIndex}].amount`, true);
              }
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
            }}
          />
        </Col>
        <Col className="col-sm-6">
          <div style={{ visibility: 'hidden', marginBottom: '4px' }}>
            <label style={{ fontSize: '12px' }}>placeholder</label>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px', height: '48px' }}>
            <MyCheckbox
              title="No Limit"
              name="infiniteQuantity"
              handlechange={(e) => {
                formik.setFieldValue(
                  `prices[${index}].variantInfo[${variantIndex}].infiniteQuantity`,
                  e.target.checked
                );
                if (e.target.checked) {
                  formik.setFieldValue(
                    `prices[${index}].variantInfo[${variantIndex}].quantity`,
                    ''
                  );
                }
              }}
              checked={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.infiniteQuantity}
              disabled={formik.values?.prices?.[index]?.limitType === 'checkbox'}
            />
            {(orgDetails?.memberPortal && formik?.values?.allow_non_members_register) && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <MyCheckbox
                  title="Members only"
                  name="forMemberOnly"
                  handlechange={(e) => {
                    formik.setFieldValue(
                      `prices[${index}].variantInfo[${variantIndex}].forMemberOnly`,
                      e.target.checked
                    );
                  }}
                  checked={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.forMemberOnly}
                />
                <InfoTooltip text="Restrict this variant to members only. Require users to log in before accessing this variant." style={{ marginBottom: '8px' }} />
              </div>
            )}
          </div>
        </Col>
      </Row>
    </>
  )
}

export default OptionalTypesItems